import React from 'react';
import PropTypes from "prop-types";
import { Modal, ModalSize } from 'components/notifications';
import { Intent } from '@blueprintjs/core';
import { Key } from 'components/key';
import './CalendarKeyModal.css';
import 'components/calendar/CalendarCell.css';
import { GridLayout } from 'components/grid';
import { ShowHide } from 'components/layout';

// Drawn with the calendar cell's own period style, so the key matches the strip exactly.
const periodKeyItems = [
    {
        name: "Weekly rest postponement",
        swatch: (
            <div className="calendar-key-period-swatch">
                <div className="calendar-cell-period-bar single"></div>
            </div>
        )
    }
];

export function CalendarKeyModal(
    {
        showKeyModal = false,
        closeKeyModal = () => { },
        isInitialising = false,
        showPostponements = false,
        activityTypesForKeyModal = [],
        calendarIconsForKeyModal = []
    }
) {
    return (
        <Modal
            isOpen={showKeyModal}
            clickOutsideClose
            onClose={closeKeyModal}
            title="Key"
            icon="warning-sign"
            intent={Intent.DANGER}
            confirmButtonText="Dismiss"
            onConfirm={closeKeyModal}
            className="calendar-key-modal"
            size={ModalSize.SMALL}
        >
            <div>
                <GridLayout numberOfColumns={2}>
                    <div>
                        <h5 className="key">Activity Types</h5>
                        <Key listVertical loading={isInitialising} items={activityTypesForKeyModal} />
                    </div>
                    <div className='spacer-bottom-small'>
                        <h5 className="key">Calendar Icons</h5>
                        <Key rounded listVertical loading={isInitialising} items={calendarIconsForKeyModal} hideBorder={true} />
                    </div>
                    <ShowHide
                        evaluator={showPostponements}
                        show={(
                            <div id="calendar-key-periods">
                                <h5 className="key">Periods</h5>
                                <Key listVertical loading={isInitialising} items={periodKeyItems} />
                            </div>
                        )}
                    />
                </GridLayout>
            </div>
        </Modal>
    );
}


CalendarKeyModal.propTypes = {
    showKeyModal: PropTypes.bool,
    closeKeyModal: PropTypes.func,
    isInitialising: PropTypes.bool,
    showPostponements: PropTypes.bool,
    activityTypesForKeyModal: PropTypes.array.isRequired,
    calendarIconsForKeyModal: PropTypes.array.isRequired
};